const urlParams = new URLSearchParams(window.location.search);
const currentPage = urlParams.get("p");

if (currentPage && currentPage !== '1') {
  let metaRobotsTag = document.querySelector('meta [name="robots"]');
  let canonicalUrlTag = document.querySelector('link[rel="canonical"]');

  if (canonicalUrlTag) {
    canonicalUrl = URL.parse(canonicalUrlTag.href);
    canonicalUrl?.searchParams.set('p', currentPage);
    canonicalUrlTag.href = canonicalUrl;
  }

  if (!metaRobotsTag) {
    metaRobotsTag = document.createElement('meta');
    metaRobotsTag.setAttribute('name', 'robots');
  }

  metaRobotsTag.setAttribute('content', 'noindex,follow');
  document.head.appendChild(metaRobotsTag);
}
